<template>
    <!-- 来访用户地域分布 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">来访用户地域分布</div>
            </div>
        </div>
        <div 
            v-if="$store.state.userInfo.leadsStatus==7" 
            v-loading="loading" 
            class="col-chart-view" 
            style="height: 236px;display: flex;justify-content: center;"  >
            <div ref="echarts" style="width:100%;"></div>
        </div>
        <div class="col-chart-content" v-else >
            <div class="col-chart-content-img">
                <img src="@/assets/image/common/dataAssistant.png" alt>
            </div>
            <div class="col-chart-content-intro">升级会员享有此服务</div>
        </div>
    </div>
</template>

<script>
import {  getDataAssistant } from "@/utils/api/dashboard";
import windowAddEvent from '@/utils/windowAddEvents';

const reg = /^[0-9a-zA-Z\s\(\)\.\!\@\#\$\%\^\&\*\-\+\=\,]+$/;
export default {
     props:{
        startTime:{
            typeof:String,
            default:''
        },
        endTime:{
            typeof:String,
            default:''
        },
        
    },
    components: {
    },
    data(){
        return {
            echartsObj :'',
            listData : [],
            loading: false,
            isNodata: false,
            arealDistributionData: {}

        }
    },
    watch: {
        startTime: {
            handler(newVal) {
                if(newVal && this.$store.state.userInfo.leadsStatus==7) {
                    this.getArealDistributionData()
                }
            },
        }
    },
    methods:{
        //获取数据
        getArealDistributionData(){
            this.loading = true;
            const params = {
                startDate: this.startTime,
                endDate: this.endTime,
                enums:['REGION']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.arealDistributionData = res.data || {};
                    this.arealDistributionData.region = res.data.region ||[];
                    // if(this.arealDistributionData.region && this.arealDistributionData.region.length!=0){
                        this.addListData();
                    // }
                    this.loading = false;

                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("System error66",err);
            })
        },

        init(currentData) {
          let options = {
            tooltip: {
                // trigger: 'axis',
                // aixsPointer:{
                //     type: 'shadow'
                // }
            },
            barWidth: 16,
            legend: {
                show: true
            },
            // barCategoryGap: 20,
            xAxis: {
                type: 'value',
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "#E0E6F1",
                        width: 1
                    }
                },

            },
            yAxis: {
                type: 'category',
                // max:500,
                // min:100,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#E0E6F1",
                        width: 1
                    }
                },
                axisTick: {
                    show: false //不显示刻度线
                },
                axisLabel: {
                    width: 120,
                    margin: 70, //离开右边的距离
                    align: "left",
                    textStyle: {
                        color: "#666", //更改坐标轴文字颜色
                        fontSize: 12 //更改坐标轴文字大小
                    },
                    formatter: (value, index)=> {
                        const len = value.length;
                        if(!reg.test(value)) {
                            if(len <= 5) {
                                return `${value.substring(0, 5)}`;
                            }else {
                                return `${value.substring(0, 5)}...`;
                            }
                        }else {
                            if(len <= 16) {
                                return `${value.substring(0, 16)}`;
                            }else {
                                return `${value.substring(0, 16)}...`;
                            }
                        }
                    }
                },
                inverse: true,
                data: currentData.tit 
            },
            grid: {
                // width: "54%",
                height: 190,
                top: 19,
                left: 90,
                // containLabel: true
            },
            series: [
                {
                    type: "bar",
                    color: ["#3A69F4"],
                    itemStyle: {
                        normal: {
                            label: {
                                show: true, //开启显示
                                position: "right", //在上方显示
                                textStyle: {
                                    //数值样式
                                    color: "#666",
                                    fontSize: 12
                                }
                            }
                        }
                    },
                    data: currentData.val
                },
                
            ]
        };
           this.echartsObj.clear();
           this.echartsObj.setOption(options);
       },
   
        handleListData(list) {
           let tit = [];
           let val = [];
           list.forEach((item) => {
               tit.push(item.region);
               val.push(item.num);
           });
           return {
               tit,
               val
           };
       },
        addListData() {
            if( this.arealDistributionData.region.length==0){
                this.arealDistributionData.region=[{region:'地区',num:0}]
            }
            const handledData = this.handleListData(this.arealDistributionData.region);
            this.init(handledData);
       },

    },
    mounted() {
        if(this.$store.state.userInfo.leadsStatus==7){
            let ele = this.$refs.echarts;
            this.echartsObj = this.$echarts.init(ele);
            this.getArealDistributionData()
            windowAddEvent('resize', this.echartsObj.resize);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>